import RealtimeReportsView from './RealimeReportsView';
export default RealtimeReportsView;